import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getTimezoneOptions,
  resolveAccessToken,
  updateTimezone,
} from '@nomiss/services';

export const timezoneQueryKeys = {
  options: (query?: string) => ['account', 'timezone', query ?? ''] as const,
};

export function useTimezoneOptions(
  query?: string,
  accessToken?: string | null,
  enabled = true,
) {
  const token = accessToken ?? resolveAccessToken();

  return useQuery({
    queryKey: [...timezoneQueryKeys.options(query), token ?? ''] as const,
    queryFn: () => getTimezoneOptions(query),
    enabled: enabled && Boolean(token),
  });
}

export function useUpdateTimezone() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (timezoneId: string) => updateTimezone(timezoneId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['account', 'timezone'],
      });
    },
  });
}
